import React from "react";
import {
  ToolTip,
  ToolTipPositionType,
} from "@components/atoms/tooltip/tooltip";
import { RenderUnreleasedFeatures } from "@src/components/molecules/render-unreleased-features/render-unreleased-features";
import { toggleUnreleasedFeaturesBorder } from "@src/cloud-connect/use-cases/toggle-unreleased-features-border";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { useI18N } from "@src/language/language-context";

interface RenderUnreleasedFeaturesInfoNavProps {
  tooltipPosition: ToolTipPositionType;
}

export const RenderUnreleasedFeaturesInfoNav = ({
  tooltipPosition,
}: RenderUnreleasedFeaturesInfoNavProps) => {
  const i18n = useI18N();

  const texts = {
    toolTipText: i18n("modules.renderUnreleasedFeaturesInfo.toolTipText"),
    infoText: i18n("modules.renderUnreleasedFeaturesInfo.infoText"),
  };

  const clickHandler = () => {
    toggleUnreleasedFeaturesBorder();
  };

  return (
    <RenderUnreleasedFeatures>
      <ToolTip content={texts.toolTipText} position={tooltipPosition}>
        <TextButton clickHandler={clickHandler} text={texts.infoText} />
      </ToolTip>
    </RenderUnreleasedFeatures>
  );
};
